import { useLoaderData } from 'react-router';

type LoaderData<T> = {
  pageData: T;
};

export default function usePageData<T>() {
  const data = useLoaderData() as unknown as LoaderData<T>;

  return data.pageData;
}
